import axios from '@/service/request';
import apiConfig from '../apiConfig';

const baseUrl = apiConfig.shortApiDomain;

// 短视频列表
export const shortVideo = params => axios.get(`${baseUrl}/shortVideo/list`, { params: { ...params } });

// 添加短视频评论
export const addComment = params => axios.post(`${baseUrl}/shortVideo/addComment`, params);

// 删除自己的评论
export const delComment = params => axios.get(`${baseUrl}/shortVideo/delComment`, { params: { ...params } });

// 评论列表
export const getComment = params => axios.get(`${baseUrl}/shortVideo/getComment`, { params: { ...params } });

// 个人中心消息评论列表
export const getSubComment = params => axios.get(`${baseUrl}/shortVideo/getSubComment`, { params: { ...params } });

// 子评论
export const getCommentReply = params => axios.get(`${baseUrl}/shortVideo/getReply`, { params: { ...params } });

// 关注
export const follow = params => axios.post(`${baseUrl}/shortVideo/follow`, params);

// 收藏短视频
export const collect = params => axios.post(`${baseUrl}/shortVideo/collect`, params);

// 点赞短视频
export const like = params => axios.post(`${baseUrl}/shortVideo/like`, params);

// 热门短视频
export const getShortHot = params => axios.get(`${baseUrl}/shortVideo/getShortHot`, { params: { ...params } });

// 热榜短视频
export const getShortHotList = params => axios.get(`${baseUrl}/shortVideo/getShortHotList`, { params: { ...params } });

// 观看短视频历史（ 用来告诉后端该视频已经看过，勿重复推送 ）
export const addWatch = params => axios.post(`${baseUrl}/shortVideo/addWatch`, params);

// 短视频分享
export const shortVideoShare = params => axios.post(`${baseUrl}/shortVideo/short_share`, params);

// 搜索短视频
export const getSearch = params => axios.get(`${baseUrl}/shortVideo/getSearch`, { params: { ...params } });

// 添加作品
export const uploadVideos = params => axios.post('/member/addWorks', params);

// 获取短视频标签
export const getLabel = params => axios.get('/public/getLabel', { params: { ...params } });

// 自定义标签
export const postLabel = params => axios.post('/posts/addTopic', params);

//  粉丝团-创建
export const addFanGroup = (params) => axios.post(`${baseUrl}/shortGroup/add`, params);

//  粉丝团-我加入的粉丝团列表
export const myFanGroupList = params => axios.get(`${baseUrl}/shortGroup/myGroup`, { params: { ...params } });

//  留言板列表
export const getMessage = params => axios.get(`${baseUrl}/shortGroup/getMessage`, { params: { ...params } });

//  短视频上下架
export const saveSHortStatus = params => axios.post(`${baseUrl}/shortVideo/addStatus`, params);

//  短视频移除
export const removeShort = params => axios.post(`${baseUrl}/shortVideo/exclusive`, params);

//  认证短视频列表
export const getCertification = params => axios.get(`${baseUrl}/shortVideo/getCertification`, { params: params });

//  查看用户是否假如粉丝团
export const getIsGroup = (params) => axios.get(`${baseUrl}/shortVideo/getIsGroup`, { params: params });
